import * as React from "react";

import { AccordionContent, AccordionItem, AccordionTrigger } from "@bcc/components/ui/accordion";
import { cn } from "@bcc/lib/utils";

type ProductFormSectionProps = {
  value: string;
  title: string;
  testId?: string;
  triggerTestId?: string;
  contentClassName?: string;
  children: React.ReactNode;
};

function ProductFormSection({ value, title, testId, triggerTestId, contentClassName, children }: Readonly<ProductFormSectionProps>) {
  return (
    <AccordionItem value={value} showLastBorder testId={testId} className="border rounded-lg bg-background px-4">
      <AccordionTrigger testId={triggerTestId}>{title}</AccordionTrigger>
      <AccordionContent forceMount className={cn(contentClassName)}>
        {children}
      </AccordionContent>
    </AccordionItem>
  );
}

export { ProductFormSection };
